import { useMutation } from '@tanstack/react-query';

// Services
import { postExport } from './exportService';

/**
 * Mutation hook to export data via POST with selected IDs
 * @param {import('@tanstack/react-query').UseMutationOptions<{ url: string }, Error, { url: string, selectedIds: string[] }, any>} [options = {}] - The mutation options
 * @returns {import('@tanstack/react-query').UseMutationResult<{ url: string }, Error, { url: string, selectedIds: string[] }, any>} The export mutation
 */
export const useExportMutation = (options = {}) => useMutation({
  mutationFn: ({ url, selectedIds }) => postExport(url, selectedIds),
  ...options,
});
